import { ReactNode } from 'react';

import { cn } from '@growtherapy/sprout-ui';

import { FormListItemBadgeVariant } from './types';

export function FormListItemBadge({
  children,
  className,
  variant,
}: {
  children: ReactNode;
  className?: string | Record<string, boolean>;
  variant?: FormListItemBadgeVariant;
}) {
  return (
    <div
      className={cn(
        'flex h-12 max-h-[3rem] w-16 max-w-[4rem] items-center justify-center rounded font-bold text-text-default',
        {
          'bg-status-success-surface': variant === FormListItemBadgeVariant.Low,
          'bg-status-error-surface text-text-default': variant === FormListItemBadgeVariant.High,
          'bg-surface-emphasis': variant === FormListItemBadgeVariant.Task,
        },
        className,
      )}
    >
      <div className='flex-row text-center leading-tight'>{children}</div>
    </div>
  );
}
